export default __webpack_public_path__ + "static/media/Sage.c40a040d.png";